import DataActionType from './data.types';
import type { Bootstrap } from '../../api/httpTismsApi';
import type { Dccb, Branch } from '../../data/tisms-api';

/** Payload assembled by the data saga after the reference fetch succeeds. */
export interface DataLoadSuccessPayload {
  bootstrap: Bootstrap;
  dccbs: Dccb[];
  branches: Branch[];
}

/** Kick off the reference/bootstrap (+ dccbs + branches) fetch. */
export const dataLoadStart = () => ({ type: DataActionType.DATA_LOAD_START });
export const dataLoadSuccess = (payload: DataLoadSuccessPayload) => ({
  type: DataActionType.DATA_LOAD_SUCCESS,
  payload,
});
export const dataLoadFailure = (error: string) => ({
  type: DataActionType.DATA_LOAD_FAILURE,
  payload: error,
});
export const dataReset = () => ({ type: DataActionType.DATA_RESET });

export type DataAction =
  | ReturnType<typeof dataLoadStart>
  | ReturnType<typeof dataLoadSuccess>
  | ReturnType<typeof dataLoadFailure>
  | ReturnType<typeof dataReset>;
